import { useContext } from "react";

import { LanguageContext } from "../context/LanguageContext";

export const useLanguageHook = () => {
  const context = useContext(LanguageContext);

  return context;
};
